export namespace AppRoutes {
  export namespace Open {
    export enum Auth {
      SIGN_IN_START = "/sign-in",
      SIGN_IN_MFA = "/mfa",
      SIGN_UP_START = "/sign-up",
      SIGN_UP_PERSONAL = "/sign-up/additional",
      SIGN_UP_COMPANY_INFO = "/sign-up/company",
      SIGN_UP_LIMITED = "/sign-up/limited",
      PASSWORD_RESET = "/reset-password",
      SUSPENDED_USER = "/suspended",
      EMAIL_VERIFICATION_SUBMIT = "/email-verification-submit",
      SERVICE_UNAVAILABLE = "/service-unavailable",
      CHECK_SIGN_IN = "/session",
    }
    export enum Apps {
      SIGN_IN = "/apps/sign-in",
      SIGN_UP = "/apps/sign-up",
      PASSWORD_RESET = "/apps/reset-password",
      RESET_PASSWORD_SUBMIT = "/apps/reset-password/submit",
      ERROR = "/apps/error",
    }
  }
  export namespace Private {
    export enum Dashboard {
      DASHBOARD_MAIN = "/private/dashboard",
    }
    export enum Inventory {
      PRODUCT_LIST = "/private/inventory/products",
      PRODUCT_LIST_STOCK = "/private/inventory/products/stock",
      PRODUCT_CREATE = "/private/inventory/products/new",
      PRODUCT_EDIT = "/private/inventory/products/edit",
      CATEGORIES = "/private/inventory/categories",
      BRANDS = "/private/inventory/brands",
      ORDER_GENERATION_EPOS = "/private/order-generation/epos",
      ORDER_GENERATION_NEW_SALES_ORDER = "/private/order-generation/new-sales-order",
      ORDERS_LIST = "/private/inventory/orders",
      ORDERS_SHOW = "/private/inventory/orders/details",
      INCOMING_INVENTORY = "/private/inventory/incoming",
      INCOMING_INVENTORY_NEW_PO_EDIT = "/private/inventory/incoming/new-purchase-order/edit",
      INCOMING_INVENTORY_NEW_TRANSFER = "/private/inventory/incoming/new-transfer",
      INCOMING_INVENTORY_NEW_PO = "/private/inventory/incoming/new-purchase-order",
      REJECTED_AND_MISSING = "/private/inventory/rejected-and-missing",
      REJECTED_AND_MISSING_CREATE = "/private/inventory/rejected-and-missing/create",
    }
    export enum Report {
      CARD_PAYMENTS = "/private/reports/card-payments",
    }

    export enum Apps {
      HOME = "/private/apps/home",
    }

    export enum Profile {
      PROFILE_SETTINGS = "/private/profile/settings",
    }
    export enum Settings {
      BUSINESS_ACCOUNT = "/private/settings/business",
      BANK_ACCOUNTS = "/private/settings/bank-accounts",
      VERIFICATION = "/private/settings/verification",
      TEAM_MANAGEMENT = "/private/settings/team",
      TEAM_MANAGEMENT_EDIT = "/private/settings/team/edit",
      ROLES = "/private/settings/roles",
      CREATE_ROLE = "/private/settings/roles/create",
      TAG_MANAGEMENT = "/private/settings/tag-management",
      PICK_UP_LOCATIONS = "/private/settings/pick-up-locations",
      API_KEYS = "/private/settings/api-keys",
      API_KEYS_GENERATE = "/private/settings/api-keys/create",
      INTEGRATIONS_ACCOUNTING = "/private/settings/integrations/accounting",
      INTEGRATIONS_ACCOUNTING_CONNECT = "/private/settings/integrations/accounting/connect",
      INTEGRATIONS_ACCOUNTING_DETAILS = "/private/settings/integrations/accounting/details",
      INTEGRATIONS_ECOMMERCE = "/private/settings/integrations/e-commerce",
      INTEGRATIONS_ECOMMERCE_CONNECT = "/private/settings/integrations/e-commerce/connect",
      INTEGRATIONS_ECOMMERCE_DETAILS = "/private/settings/integrations/e-commerce/details",
      INTEGRATIONS_MARKETPLACES = "/private/settings/integrations/marketplaces",
      INTEGRATIONS_MARKETPLACES_CONNECT = "/private/settings/integrations/marketplaces/connect",
      INTEGRATIONS_MARKETPLACES_DETAILS = "/private/settings/integrations/marketplaces/details",
      INTEGRATIONS_OTHERS = "/private/settings/integrations/other-apps",
      INTEGRATIONS_OTHERS_CONNECT = "/private/settings/integrations/other-apps/connect",
      INTEGRATIONS_OTHERS_DETAILS = "/private/settings/integrations/other-apps/details",
      INTEGRATIONS_WAREHOUSE = "/private/settings/integrations/warehouse-management",
      INTEGRATIONS_WAREHOUSE_CONNECT = "/private/settings/integrations/warehouse-management/connect",
      INTEGRATIONS_WAREHOUSE_DETAILS = "/private/settings/integrations/warehouse-management/details",
      CUSTOMISATION_PAYMENT_PAGE = "/private/settings/customisation/payment-page",
      CUSTOMISATION_EMAIL_NOTIFICATIONS = "/private/settings/customisation/email-notifications",
      CUSTOMISATION_INVOICE_DESIGN = "/private/settings/customisation/invoice-design",
      CUSTOMISATION_FENA_CHECKOUT_FLOW = "/private/settings/customisation/fena-checkout-flow",
      INTEGRATIONS_COURIERS = "/private/settings/integrations/couriers",
      INTEGRATIONS_COURIERS_CONNECT = "/private/settings/integrations/couriers/connect",
      INTEGRATIONS_CARRIERS = "/private/settings/integrations/carriers",
      INTEGRATIONS_CARRIERS_CONNECT = "/private/settings/integrations/carriers/connect",
      INTEGRATIONS_CARRIERS_VIEW = "/private/settings/integrations/carriers/view",
      INTEGRATIONS_PAYMENTS = "/private/settings/integrations/payments",
      INTEGRATIONS_PAYMENTS_CONNECT = "/private/settings/integrations/payments/connect",
      INTEGRATIONS_PAYMENTS_ADDITIONAL_DETAILS = "/private/settings/integrations/payments/additional-details",
      INTEGRATIONS_APPS = "/private/settings/apps",
      INTEGRATIONS_APPS_LIST = "/private/settings/apps/list",
      INTEGRATIONS_APPS_DETAILS = "/private/settings/apps/details",
      LOCATIONS_LIST = "/private/settings/locations",
      COMMERCIAL_INVOICES = "/private/settings/commercial-invoices",
      BILLING_CHOOSE_PLAN = "/private/settings/billing-and-packages",
      BILLING_ORDER_SUMMARY = "/private/settings/billing-and-packages/order-summary",
      BILLING_AND_PAYMENTS = "/private/settings/billing-and-packages/billing-and-payment",
      BILLING_HISTORY = "/private/settings/billing-and-packages/billing-history",
      BILLING_CHECKOUT = "/private/settings/billing-and-packages/checkout",
      BILLING_PURCHASE_CREDITS = "/private/settings/billing-and-packages/purchase-credits",
      REMINDERS_LIST = "/private/settings/reminders",
      REMINDERS_CREATE = "/private/settings/reminders/create",
      SYNC_MANAGEMENT = "/private/settings/sync-management",
      SYNC_MANAGEMENT_DETAILS = "/private/settings/sync-management/details",
      TERMINAL_MANAGEMENT_LIST = "/private/settings/terminal-management",
      TERMINAL_MANAGEMENT_CREATE = "/private/settings/terminal-management/create",
      TERMINAL_MANAGEMENT_EDIT = "/private/settings/terminal-management/edit",
      WHOLESALE_TIER_PRICING = "/private/settings/wholesale-tier-pricing",
      TAX_LEVELS = "/private/settings/tax-levels",
      CURRENCY = "/private/settings/currency",
      SEGMENTS_CUSTOMER_SEGMENTS = "/private/settings/segments/customer-segments",
      SEGMENTS_LOCATION_SEGMENTS = "/private/settings/segments/location-segments",
    }
    export enum Payments {
      BULK_PAYMENTS_LIST = "/private/payments/bulk-payments",
      BULK_PAYMENTS_RUNS = "/private/payments/bulk-payments/payment-runs",
      BULK_PAYMENTS_RUN_CREATE = "/private/payments/bulk-payments/payment-runs/create",
      BULK_PAYMENTS_DETAILS = "/private/payments/bulk-payments/payment-runs/details",
      BULK_PAYMENTS_DETAILS_CONFIRM_PAYMENT = "/private/payments/bulk-payments/payment-runs/details/confirm-payment",
      BULK_PAYMENTS_DETAILS_CONFIRM_PAYMENT_STATUS = "/private/payments/bulk-payments/payment-runs/payment-run-status",
      BULK_PAYMENTS_EDIT_INDIVIDUAL_PAYMENT = "/private/payments/bulk-payments/payment-runs/edit-individual-payment",
      BULK_PAYMENTS_UPCOMING = "/private/payments/bulk-payments/upcoming-payments",
      BULK_PAYMENTS_UPCOMING_CREATE = "/private/payments/bulk-payments/upcoming-payments/create",
      BULK_PAYMENTS_UPCOMING_EDIT = "/private/payments/bulk-payments/upcoming-payments/edit",
      TRANSACTIONS_LIST = "/private/payments/transactions",
      TRANSACTION_DETAILS_DRAWER = "/private/payments/transactions/drawer/details",
      FENA_PAYMENTS_LIST = "/private/payments/fena",
      FENA_PAYMENTS_QR = "/private/payments/fena_qr",
      FENA_PAYMENTS_MOBILE = "/private/payments/fena_mobile",
      PAYMENTS_CASH = "/private/payments/cash",
      PAYMENTS_CARD = "/private/payments/card",
      PAYMENTS_CHECKOUT = "/private/payments/checkout",
      PAYMENTS_OTHER = "/private/payments/other",
      RECURRING_PAYMENTS = "/private/payments/recurring",
      RECURRING_PAYMENT_CREATE = "/private/payments/recurring/create",
      RECURRING_PAYMENT_EDIT = "/private/payments/recurring/edit",
      REFUND = "/private/payments/transactions/refund",
      REFUND_CONFIRM = "/private/payments/transactions/refund/confirm",
      REFUND_QR = "/private/payments/transactions/refund/QR",
      ORDER_REFUND_DRAWER = "/private/payments/fena/drawer/order-refund",
    }
    export enum Invoices {
      INVOICES_LIST = "/private/invoices",
      INVOICES_CREATE_WHOLESALE = "/private/invoices/create-wholesale",
      INVOICES_CREATE_RETAIL = "/private/invoices/create-retail",
      INVOICES_EDIT_WHOLESALE = "/private/invoices/edit-wholesale",
      INVOICES_EDIT_RETAIL = "/private/invoices/edit-retail",
      INVOICES_DETAILS = "/private/invoices/details",
      INVOICES_PREVIEW_INVOICE = "/private/invoices/preview",
      COMMERCIAL_INVOICES_LIST = "/private/commercial-invoices",
      COMMERCIAL_INVOICES_EDIT = "/private/commercial-invoices/edit",
      COMMERCIAL_INVOICES_DETAILS = "/private/commercial-invoices/details",
      QUOTES_LIST = "/private/quotes",
      QUOTES_CREATE_WHOLESALE = "/private/quotes/create-wholesale",
      QUOTES_CREATE_RETAIL = "/private/quotes/create-retail",
      QUOTES_EDIT_WHOLESALE = "/private/quotes/edit-wholesale",
      QUOTES_EDIT_RETAIL = "/private/quotes/edit-retail",
      QUOTES_DETAILS = "/private/quotes/details",
    }
    export enum Customers {
      CUSTOMERS_LIST = "/private/inventory/customers",
      DETAILS = "/private/inventory/customers/details",
      EDIT = "/private/inventory/customers/:id/edit",
      ADDRESS = "/private/inventory/customers/:id/add-new",
    }
    export enum Suppliers {
      SUPPLIERS = "/private/inventory/suppliers",
      SUPPLIER_DETAILS = "/private/inventory/suppliers/details",
      EDIT = "/private/inventory/suppliers/_id/edit",
    }
    export enum Shipments {
      SHIPMENTS_PICKING_LIST = "/private/shipments/picking",
      SHIPMENTS_ORDER_DETAILS = "/private/shipments/picking/details",
      SHIPMENTS_PICKER_LIST = "/private/shipments/picking/picker",
      SHIPMENTS_PICKER_DETAILS = "/private/shipments/picking/picker/details",
      SHIPMENTS_DESPATCH_LIST = "/private/shipments/despatch",
      SHIPMENTS_DESPATCH_DETAILS = "/private/shipments/despatch/details",
      SHIPMENTS_MANIFEST_HISTORY = "/private/shipments/manifest-history",
    }
    export enum Partner {
      MERCHANTS_LIST = "/private/partner/merchants",
      MERCHANTS_CREATE = "/private/partner/merchants/create",
      MERCHANTS_DETAILS = "/private/partner/merchants/details",
      MERCHANTS_ANALYTICS = "/private/partner/merchants/analytics",

      TRANSACTIONS_LIST = "/private/partner/transactions",

      DASHBOARD = "/private/partner/dashboard",

      PARTNER_BUSINESS_ACCOUNT = "/private/partner/settings/business",
      PARTNER_API_KEYS = "/private/partner/settings/api-keys",
      PARTNER_API_KEYS_GENERATE = "/private/partner/settings/api-keys/create",
      PARTNER_CUSTOMISATION_EMAIL_NOTIFICATIONS = "/private/partner/settings/customisation/email-notifications",
      PARTNER_DASHBOARD = "/private/partner/settings/customisation/partner-dashboard",
      PARTNER_WEBHOOK_SETTINGS = "/private/partner/settings/partner-settings",
      PARTNER_BANK_ACCOUNTS = "/private/partner/settings/bank-accounts",
    }
  }
}
